module.exports = __webpack_public_path__ + "img/clique_nos_pratos.6e170989.png";